import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { ConfirmTransferScreenProps } from "../useConfirmTransfer";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";

import { BodyLargeRegular, HeadlineMedium } from "../../../components/font";
import { Button, tokens } from "@manifesthhqinc/ui-library";

import Flex from "../../../layout/flex";
import IDVector from "./IDVer.svg";
import { VectorWrapper } from "../../post-transfer/styles";

const IDVerificationScreen = (props: ConfirmTransferScreenProps) => {
  const { showPersona } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="id-verification-start">
        <Container>
          <Flex $flexGap={8} $flexDirection="column">
            <HeadlineMedium $textAlign="center">We need to verify your identity for your annuity</HeadlineMedium>
            <BodyLargeRegular $textAlign="center" $color={tokens.color.text.secondary}>
              We’ll securely verify your identity using a valid ID. This should only take a few minutes.
            </BodyLargeRegular>
          </Flex>
          <VectorWrapper>
            <img src={IDVector} alt="id-verification" />
          </VectorWrapper>
          {/* <p className="form-description pr-20 pl-20" style={{ marginBottom: 0 }}></p> */}
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="start-id-verification" onClick={showPersona} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};
export default IDVerificationScreen;
